// We need underscores for calendar and simple templating.
window.underscore = _ = require('underscore');

var moment = require('moment-timezone'); // TODO: move to ktjform-js
// Set default timezone for moment.
moment.tz.setDefault("Europe/Stockholm"); // TODO: move to ktjform-js

require('moment/locale/sv');  // TODO: move to ktjform-js
window.moment = moment;   // TODO: move to ktjform-js


// Bootstrap calendar main library
var bscalendar = require('../js/bootstrap-calendar-fork.js');  // TODO: move to ktjform-js

// Globally load calendar function.
window.bookingCalendar = require('../js/bookingcalendar.js');  // TODO: move to ktjform-js

// underscore templates variables
window.utemplates = require('./underscoretemplates.js'); // TODO: move to ktjform-js ??


$(document).ready(function () {

    window.bookingCalendar = require('../js/bookingcalendar.js');  // TODO: move to ktjform-js

    // Moved in from main.js - below lcMod39
    var lcMod_43_booking_pri = require('../modules/lc-mod-43-booking-pri/block-module-booking-pri.js');
    var lcMod_44_plusminus = require('../modules/lc-mod-44-plusminus/block-module-44-plusminus.js');
   // var userInputSimulation = require('../js/userinputsimulation.js');


    // Mini form dependencys, hard to move here.
    var block_module_46_booking_form = require('../modules/lc-mod-46-booking-form/block-module-46-booking-form.js');
   var block_module_46_booking_form_validation = require('../modules/lc-mod-46-booking-form/block-module-46-booking-form-validation.js');
  var block_module_46_booking_form_navigation = require('../modules/lc-mod-46-booking-form/block-module-46-booking-form-navigation.js');
    var block_module_46_booking_form_interactions = require('../modules/lc-mod-46-booking-form/block-module-46-booking-form-interactions.js');
    var block_module_46_booking_form_price = require('../modules/lc-mod-46-booking-form/block-module-46-booking-price.js');
    var block_module_46_booking_form_input_count = require('../modules/lc-mod-46-booking-form/block-module-46-booking-form-input-count.js');
    var block_module_46_booking_form_checkbox_show = require('../modules/lc-mod-46-booking-form/block-module-46-booking-form-checkbox-show.js');
    var block_module_46_booking_form_radio = require('../modules/lc-mod-46-booking-form/block-module-46-booking-form-radio.js');




    var block_module_47_inquiry_form = require('../modules/lc-mod-47-inquiry-form/block-module-47-inquiry-form.js');
    var block_module_47_inquiry_form_validation = require('../modules/lc-mod-47-inquiry-form/block-module-47-inquiry-form-validation.js');
    var block_module_47_inquiry_form_navigation = require('../modules/lc-mod-47-inquiry-form/block-module-47-inquiry-form-navigation.js');
    var block_module_47_inquiry_form_interactions = require('../modules/lc-mod-47-inquiry-form/block-module-47-inquiry-form-interactions.js');
    //   var block_module_47_inquiry_form_price = require('../modules/lc-mod-47-inquiry-form/block-module-47-inquiry-price.js');
    var block_module_47_inquiry_form_input_count = require('../modules/lc-mod-47-inquiry-form/block-module-47-inquiry-form-input-count.js');
    var block_module_47_inquiry_form_select = require('../modules/lc-mod-47-inquiry-form/block-module-47-inquiry-form-select.js');
    var block_module_47_inquiry_form_numberfree = require('../modules/lc-mod-47-inquiry-form/block-module-47-inquiry-form-numberfree.js');
    var block_module_47_inquiry_form_addmore = require('../modules/lc-mod-47-inquiry-form/block-module-47-inquiry-form-addmore.js');


    var block_module_47_inquiry_form_checkbox_show = require('../modules/lc-mod-47-inquiry-form/block-module-47-inquiry-form-checkbox-show.js');

    var block_module_48_breadcrumbs_page = require('../modules/lc-mod-48-breadcrumbs-page/block-module-48-breadcrumbs-page.js');


    //   var block_module_47_inquiry_form_radio = require('../modules/lc-mod-47-inquiry-form/block-module-47-inquiry-form-radio.js');

});